// libs
import React, { useCallback } from 'react';
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import Skeleton from 'react-loading-skeleton';
import { useHistory } from 'react-router-dom';

// CSS
import 'react-loading-skeleton/dist/skeleton.css'

// utils & functions
import DateFormated from "../Utils/Date/Date";

// hoc
import Aux from "../../hoc/Auxiliary";

// components
import CardGeneric from "../Cards/CardGeneric";
import TankLevelGraph from "./TankLevelGraph";

const TankCard = (props) => {
    if(!props.tank) return false;

    const { tank, dipDevice } = props;
    const { t, i18n } = useTranslation();
	const history = useHistory();

    const nextDeliveryDescription = (i18n.language === "fr" ? tank.nextDeliveryFrenchDescription : tank.nextDeliveryEnglishDescription);

    const isDate = (date) => {
        let dateFormat = /(^\d{4}[-]\d{2}[-]\d{2}$)/;
        return dateFormat.test(date);
    }

    const getDateDisplay = (tank, days) => {
        if (tank.shippingFrequency.code === "J") {
            return (<strong>
                {tank.shippingFrequencyValue + ' '}
                {(i18n.language === "fr"
                    ? tank.shippingFrequency.descriptionFr
                    : tank.shippingFrequency.descriptionEn)}
                {tank.hasWaterHeater ? ' + ' + t('account.tabs.tanks.waterheader') : ''}
            </strong>);

        } else if (tank.shippingFrequency.code === "O") {
            return <table className="shipping-freq">
                <tbody>
                <tr>
                    <td className={(days.dim ? 'active' : '')}>{t('account.tabs.tanks.dim')}</td>
                    <td className={(days.lun ? 'active' : '')}>{t('account.tabs.tanks.lun')}</td>
                    <td className={(days.mar ? 'active' : '')}>{t('account.tabs.tanks.mar')}</td>
                    <td className={(days.mer ? 'active' : '')}>{t('account.tabs.tanks.mer')}</td>
                    <td className={(days.jeu ? 'active' : '')}>{t('account.tabs.tanks.jeu')}</td>
                    <td className={(days.ven ? 'active' : '')}>{t('account.tabs.tanks.ven')}</td>
                    <td className={(days.sam ? 'active' : '')}>{t('account.tabs.tanks.sam')}</td>
                </tr>
                </tbody>
            </table>

        } else {
            return (<strong>
                {
                    i18n.language === "fr"
                        ? tank.shippingFrequency.descriptionFr
                        : tank.shippingFrequency.descriptionEn
                }
                {tank.hasWaterHeater ? ' + ' + t('account.tabs.tanks.waterheader') : ''}
            </strong>);
        }
    }

	const navigateToSubaccount = useCallback(() => history.push('/accounts/'+props.subAccountCode+'#deliveries'), [history]);

	let readingDeviceAddress = [];
	if(dipDevice){
		if(dipDevice.address){ readingDeviceAddress.push(dipDevice.address); }
		if(dipDevice.city){ readingDeviceAddress.push(dipDevice.city); }
		if(dipDevice.region){ readingDeviceAddress.push(dipDevice.region); }
		if(dipDevice.country){ readingDeviceAddress.push(dipDevice.country); }
		if(dipDevice.postalCode){ readingDeviceAddress.push(dipDevice.postalCode); }
	}

    const getDateText = (date) => {

        const today = new Date();
        const currentdate = new Date(date);
        let maxDate = new Date(date);
        maxDate.setDate(currentdate.getDate() + 14);
        if (today > currentdate && maxDate < today) {
            return t('account.tabs.tanks.notplanned')
        } else {
            return t('account.tabs.tanks.inthenextdays')
        }
    }

    return (
        <CardGeneric title={tank.tankName} additionalClasses={['card--tank', 'tank', 'tank__card']}>
			{
				(props.subAccountName) ? (
					<h4 className="tank__card__subaccount-title">
						<strong>{ props.subAccountName }</strong>
					</h4>
				) : ''
			}
			{
				(props.loadingDip) ? (
					<div className="tank__card__reading-device__intro">
						<Skeleton height={10} width={120} />
						<Skeleton count={2} />
					</div>
				) : (
					(dipDevice) && (
						<div className="tank__card__reading-device__intro">
							{ (dipDevice.dipReadingDeviceName) && (
								<h4 className="tank__card__subaccount-title">
									<strong>{ dipDevice.dipReadingDeviceName }</strong>
								</h4>
							) }
							{ (readingDeviceAddress && readingDeviceAddress.length > 0) && (
								<p className="">{ readingDeviceAddress.join(', ') }</p>
							) }
						</div>
					)
				)
			}
			<div className="row flex-row flex-md-row-reverse align-items-stretch">
				<div className="col-12 col-md-4 col-lg-6 tank__readings mb-4">
					{
						(props.loadingDip)
							? <Skeleton height={110} />
							: (dipDevice)
								? (<TankLevelGraph level={ (dipDevice.lastLevel) ? dipDevice.lastLevel : null }/>  )
								: ''
					}
				</div>
				<div className="col-12 col-md-8 col-lg-6 tank__attributes mb-4">
					<p className="tank__attribute">
						<span className="tank__attribute__label">{t("account.tabs.tanks.product")}</span>
						<strong className="tank__attribute__value">
							{
								i18n.language === "fr"
									? tank.product.descriptionFr
									: tank.product.descriptionEn
							}
						</strong>
					</p>
					<p className="tank__attribute">
						<span className="tank__attribute__label">{t("account.tabs.tanks.capacity")}</span>
						<strong className="tank__attribute__value tank__attribute__value--2x">{tank.capacity.formattedUnitValue}</strong>
					</p>
				</div>
			</div>
			<div className="tank__links">
				{
					(!props.loadingDip && dipDevice)
					? (
						<Link to={`/tanks/tank/${tank.tankId}`} className="link link--red link--upper link--fs-14 link--accent">
							<strong>{ t('tanks.details_button') }</strong>&nbsp;&nbsp;
							<i className="fas fa-angle-right"></i>
						</Link>
					)
					: ''
				}
			</div>
            {
                tank.tankTag != "" && tank.tankTag != "0000000" ?
                    <div>
                        {t('account.tabs.tanks.tag')}&nbsp;:&nbsp;
                        <strong>{tank.tankTag}</strong>
                    </div> :
                    <div className="tank__deliveryinfos">
                        <div className="row">
                            <div className="col-12 col-sm-6">
                                {t('account.tabs.tanks.frequence')}<br/>
                            </div>
                            <div className="col-12 col-sm-6">
                                {
                                    getDateDisplay(tank, {
                                        "dim": tank.shippingOnSunday,
                                        "lun": tank.shippingOnMonday,
                                        "mar": tank.shippingOnTuesday,
                                        "mer": tank.shippingOnWednesday,
                                        "jeu": tank.shippingOnThursday,
                                        "ven": tank.shippingOnFriday,
                                        "sam": tank.shippingOnSaturday,
                                    })
                                }
                            </div>
                        </div>

                        {
                            <div className="row">
                                <div className="col-12 col-sm-6">
                                    {t('account.tabs.tanks.lastdelivery')}<br/>
                                </div>
                                <div className="col-12 col-sm-6">
                                    <strong>
                                        {(tank.lastDeliveryDate != null && tank.lastDeliveryDate != '1899-12-30T00:00:00') ?
                                            <DateFormated date={tank.lastDeliveryDate}
                                                          withTime={false}/> : t('account.tabs.tanks.nodelivery')
                                        }
                                    </strong>
                                </div>
                            </div>
                        }

                        {
                            (tank.shippingFrequency.code === "N" || nextDeliveryDescription === "") ? '' :
                                <div className="row">
                                    <div className="col-12 col-sm-6">
                                        {t('account.tabs.tanks.nextdelivery')}<br/>
                                    </div>
                                    <div className="col-12 col-sm-6">
                                        <Aux>
                                            <strong>
                                                {
                                                    (isDate(nextDeliveryDescription)) ?
                                                        <DateFormated
                                                            date={nextDeliveryDescription + 'T12:00:00Z'}
                                                            withTime={false}/> :
                                                        nextDeliveryDescription
                                                }
                                            </strong>
                                        </Aux>
                                    </div>
                                </div>
                        }
                    </div>
            }

            {
                (tank.isOrderEntryAllowed) ?
                    (tank.isDeliveryInProcess) ? (
						<div className="card__action mt-2">
							<button onClick={(e) => {
										e.preventDefault();
										if(props.hasOwnProperty('refreshTabs') && props.refreshTabs) {
											props.refreshTabs('deliveries');
											if(props.hasOwnProperty('changeDateFilter') && props.changeDateFilter) {
												props.changeDateFilter('current_orders');
											}
										} else {
											navigateToSubaccount();
										}

									}}
								 	className="btn btn--raised btn--fs-12 w-100">
								{t('popuporder.btnfollow')}&nbsp;&nbsp;<i className="fas fa-angle-right"></i>
							</button>
						</div>)
					: (
						<div className="card__action mt-2">
							<button onClick={() => props.onOrderClick(tank)}
									className="btn btn--outline btn--outline--black btn--fs-12 w-100">
								{t('popuporder.btn')}&nbsp;&nbsp;<i className="fas fa-angle-right"></i>
							</button>
						</div>
					)
				: (
					<div className="card__action mt-2" style={{position: 'relative'}}>
						<OverlayTrigger overlay={
								<Tooltip id="tooltip-top">
									{
										i18n.language === "fr"
											? tank.orderEntryUnallowedMessage.descriptionFr
											: tank.orderEntryUnallowedMessage.descriptionEn
									}
								</Tooltip>
							}>
							<div className="btn-info-tooltip"><i className="far fa-info-circle"></i></div>
						</OverlayTrigger>
						<button className="btn btn--outline btn--outline--black disabled btn--fs-12 w-100">
							{t('popuporder.btn')}&nbsp;&nbsp;<i className="fas fa-angle-right"></i>
						</button>
					</div>
				)
            }

        </CardGeneric>
    );
};

export default TankCard;
